import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToast } from "../../Redux/Slices/toast-slice";
import { message } from "antd";
import { fetchApi } from "../../utlis/axios";

const SubscriptionPlanOverview = () => {
  const { theme } = useSelector((state) => state.theme);
  const { isLogin, userInfo } = useSelector((state) => state?.auth || {});
  const [isLoading, setIsloading] = useState(false)
  const [reason, setReason] = useState("");
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleCancell = async () => {
    if(!reason){
      dispatch(addToast({ message: "Please provide a reason for cancellation" , type:'error'}))
      return
    }
    setIsloading(true)
    try {
      const res = await fetchApi.post('cancel-subscription/', {
        reason: reason,
      
      }, {
        headers: {
          Authorization: `Bearer ${userInfo?.access_token}`
        }
      })
      if(res.status === 201){
        dispatch(addToast({ message: "Subscription cancellellation request recorded" , type:'success'}))
        setIsCancelPopupOpen(false)
        setReason('')
      }
    } catch (error) {
      dispatch(addToast({ message: "Something went wrong please try again " }))
    } finally {
      setIsloading(false)
    }
  }

  const isDark = theme === "dark";
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

  function getNextBillingDate(updatedAt, interval) {
    const date = new Date(updatedAt);
  
    if (interval === "month") {
      date.setMonth(date.getMonth() + 1);
    } else if (interval === "year") {
      date.setFullYear(date.getFullYear() + 1);
    }
  
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return (
    <div className="flex flex-col items-center justify-center w-full">
      {isCancelPopupOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-10"
            style={{ top: "95px" }}
          ></div>
          <div
            className="fixed inset-0 flex items-center justify-center z-20"
            style={{ top: "95px" }}
          >
            <div
              className={`w-[90%] max-w-md rounded-2xl shadow-lg p-6 relative fontRoboto ${isDark ? "bg-[#212529] text-white" : "bg-white text-black"
                }`}
            >
              <button
                className={`absolute top-4 right-4 rounded-full p-1 ${isDark ? "text-white bg-gray-600" : "text-black bg-[#D8D8D8]"} `}
                onClick={() => setIsCancelPopupOpen(false)}
              >
                <IoClose className="w-6 h-6" />
              </button>

              <h2 className="text-xl font-semibold text-center mb-4">
                Cancel Subscription
              </h2>

              <p className="text-base text-center mb-6">
                Are you sure you want to cancel your subscription?
                <br />
                You’ll retain access until your billing cycle ends.
              </p>

              <div className="mb-4">
                <label className="text-base font-medium mb-2 block">
                  Why do you want to cancel? <span className="text-xs text-gray-400">(optional)</span>
                </label>
                <textarea
                  className={`w-full resize-none p-3 rounded-lg text-sm border focus:outline-none ${isDark
                    ? "bg-transparent border-[#3f434a] text-white placeholder-gray-400"
                    : "bg-white border-gray-300 text-black placeholder-gray-500"
                    }`}
                  rows="4"
                  placeholder="Let us know how we can improve...." value={reason} onChange={(e) => setReason(e.target.value)}
                />
              </div>

              <div className="flex justify-center items-center w-3/4 gap-4 mt-6">
                <button
                  onClick={() => setIsCancelPopupOpen(false)}
                  className={`px-5 py-2 rounded-full text-base font-medium border transition ${isDark
                    ? "bg-transparent border-gray-600 text-white "
                    : "bg-transparent border-gray-400 text-black "
                    }`}
                >
                  Keep Plan
                </button>

                <button
                  onClick={() => handleCancell()}
                  className="px-5 py-2 rounded-full heroButton " disabled={isLoading}
                >
                  {isLoading ? 'Cancelling...' : 'Yes, Cancel'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="md:px-8 px-4 my-6 w-full text-start">
        <h1 className={`text-[26px] fontRoboto font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'}`}>My Subcription</h1>
      </div>
      <hr className="mb-4 w-full " />
      <div className="md:px-8 px-4 py-4 w-full flex flex-col items-center justify-center">
        <div
          className={`rounded-2xl max-w-screen-lg w-full fontPoppins p-6 md:p-10 shadow-md border text-sm md:text-base ${isDark
            ? " border-[#3A3B3C] text-white"
            : "bg-white border-[#E5E7EB] text-black"
            }`}
        >
          <h2 className="text-xl md:text-2xl font-semibold mb-1">Enterprise</h2>
          <p className="text-sm md:text-base mb-6 text-gray-500 dark:text-gray-300">
            Fixed yearly billing plan for companies with 100+ users. Premium features included.
          </p>

          {/* Plan Overview */}
          <div className="border-t pt-6 mb-4 flex items-start justify-between w-full gap-4 ">
            <h3 className="font-semibold mb-2 md:w-1/4 w-auto">Plan Overview</h3>
            <div className="grid grid-cols-1 gap-4 mb-4 md:w-1/2">
              <div>
                <p className="text-gray-400">Plan Name</p>
                <p>{userInfo?.user?.plan?.name}</p>
              </div>
              <hr />
              <div>
                <p className="text-gray-400">Users Covered</p>
                <p>{userInfo?.user?.plan?.number_of_users}</p>
              </div>
              <hr />
              <div>
                <p className="text-gray-400">Included Features</p>
                <p>{userInfo?.user?.plan?.description}</p>
              </div>
            </div>
          </div>

          {/* Billing Information */}
          <div className="border-t pt-6 mb-4 flex items-start justify-between w-full gap-4">
            <h3 className="font-semibold mb-2 md:w-1/4 w-auto">Billing Information</h3>
            <div className="grid grid-cols-1 md:w-2/4 gap-4 mb-4">
              <div>
                <p className="text-gray-400">Billing Cycle</p>
                <p>{userInfo?.user?.plan?.interval}</p>
              </div>
              <hr />
              <div>
                <p className="text-gray-400">Total Price</p>
                <p>{userInfo?.user?.plan?.amount} / {userInfo?.user?.plan?.interval}</p>
              </div>
              <hr />
              <div>
                <p className="text-gray-400">Next Renewal</p>
                <p>{getNextBillingDate(userInfo?.user?.plan?.updated_at, userInfo?.user?.plan?.interval)}</p>
              </div>
            </div>
          </div>

          {/* Status */}
          <div className="border-t pt-6 mb-4 flex justify-between items-start w-full gap-4">
            <h3 className="font-semibold mb-2 md:w-1/2">Status</h3>
            <div className="flex flex-col items-start gap-2 md:w-2/4">
              <p className="text-gray-400">Subscription</p>
              <span className="px-3 py-1 rounded-full text-xs font-medium text-green-800 bg-green-200 dark:text-green-300 dark:bg-green-900">
                {userInfo?.user?.is_active ? 'Active' : 'Inactive'}
              </span>
              {/* Actions */}
              <div className="flex flex-col md:flex-row gap-4 mt-6">
                <button
                  className={`rounded-full px-6 py-2 border font-medium ${isDark
                    ? "border-white text-white hover:bg-white hover:text-black"
                    : "border-black text-black hover:bg-black hover:text-white"
                    }`} onClick={() => setIsCancelPopupOpen(true)}
                >
                  Cancel Subscription
                </button>
                <button className="rounded-full px-6 py-2 heroButton" onClick={() => navigate('/dashboard/changeplan')}>
                  Change Plan
                </button>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlanOverview;
